import { Alert } from "@onengine/component-library";
import CopyableText from "@/components/ui/CopyableText/CopyableText";

interface AssistantErrorAlertProps {
  text: string;
  reference?: string;
}

export function AssistantErrorAlert({ text, reference }: AssistantErrorAlertProps) {
  return (
    <div role="alert">
      <Alert
        title="The assistant could not finish"
        message={text}
        type="danger"
        variant="plain"
        size="small"
        presentation="inline"
      />
      {reference && (
        <CopyableText textToCopy={reference} align="center">
          <small>Ref: {reference}</small>
        </CopyableText>
      )}
    </div>
  );
}
